/**
 * DEBUG-breakpoint-upstream-message.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Message } from "../general/message";
import { MessageTag } from "../message-tag";

/**
 * The client sends a {@link DebugBreakpointUpstreamMessage} to trigger a server
 * breakpoint or other contextually-relevant debug-specific behavior.
 */
export class DebugBreakpointUpstreamMessage extends Message
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.DBG_UP_BREAKPOINT;
	public static tag : MessageTag = MessageTag.DBG_UP_BREAKPOINT;

  public expectsReply () : boolean
  {
    return false;
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/debug/DEBUG-breakpoint-upstream-message.ts